import axios from "../configs/axios-instances";
import apiPath from "../constants/api-path.constant";

const scannerApi = {
  handleLogin: ({ payload, success, error, final }) => {
    const {
      scanner: { login },
    } = apiPath;
    axios.postRequest({ path: login, payload, success, error, final });
  },
  activateScanner: ({ payload, success, error, final }) => {
    const {
      scanner: { activateScanner },
    } = apiPath;
    axios.postRequest({
      path: activateScanner,
      payload,
      success,
      error,
      final,
    });
  },
  resendScannerActivation: ({ payload, success, error, final }) => {
    const {
      scanner: { resendScannerActivation },
    } = apiPath;
    axios.postRequest({
      path: resendScannerActivation,
      payload,
      success,
      error,
      final,
    });
  },
  verifyScanner: ({ payload, success, error, final }) => {
    const {
      scanner: { verifySession },
    } = apiPath;
    axios.postRequest({ path: verifySession, payload, success, error, final });
  },
  verifyTicket: ({ payload, success, error, final }) => {
    const {
      scanner: { verifyTicket },
    } = apiPath;
    axios.postRequest({ path: verifyTicket, payload, success, error, final });
  },
  confirmTicket: ({ payload, success, error, final }) => {
    const {
      scanner: { confirmTicket },
    } = apiPath;

    axios.postRequest({
      path: confirmTicket,
      payload,
      success,
      error,
      final,
    });
  },
  eventList: ({ params, payload, success, error, final }) => {
    const {
      scanner: { eventList },
    } = apiPath;
    axios.getRequest({
      path: eventList,
      params,
      payload,
      success,
      error,
      final,
    });
  },
  listBookingsForEvent: ({
    eventId,
    params,
    payload,
    success,
    error,
    final,
  }) => {
    const {
      scanner: { listBookingsForEvent },
    } = apiPath;
    const path = listBookingsForEvent(eventId);
    axios.getRequest({
      path,
      params,
      payload,
      success,
      error,
      final,
    });
  },
};

export default scannerApi;
